import React, { useContext, useState, useEffect } from 'react';
import styles from './style.module.scss';
import { Grid, Paper, Button, CircularProgress } from '@material-ui/core';
import { Context as AuthContext } from '../../context/AuthContext';
import { useHistory } from 'react-router-dom';
import { sendBroadcast } from './indexApi';
import AlertComponent from '../../components/AlertComponent';

const SMSBroadcast = () => {
    const { state } = useContext(AuthContext);
    const loginData = state.userData;
    const history = useHistory();
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({
        msg: null,
        color: null
    })
    const [btnLoader, setBtnLoader] = useState(false);
    const [referralBtnLoader, setReferralBtnLoader] = useState(false);
    const [referralLink, setReferralLink] = useState(null);
    const [referralCode, setReferralCode] = useState(null);
    const errorColor = '#f44336';
    const successColor = '#4caf50';

    useEffect(()=>{
        getSmsLink();
    },[])

    const getSmsLink = () => {
        let path;
        if (
            window.location.href.indexOf("test") > -1 ||
            window.location.href.indexOf("localhost") > -1
        ) {
            path = `https://gostor.vercel.app/home?referral=`;
        }
        else {
           path = `https://gostor.com/home?referral=`;
        }
        if(loginData && loginData.seller_id === 30) {
            setReferralLink(path+'GOAPRELEC');
            setReferralCode('GOAPRELEC');
        }
        else if(loginData && loginData.seller_id === 264) {
            setReferralLink(path+'GOARIHANT');
            setReferralCode('GOARIHANT');
        }
        else if(loginData && loginData.seller_id === 299) {
            setReferralLink(path+'GOESHOPEE');
            setReferralCode('GOESHOPEE');
        }
        else if(loginData && loginData.seller_id === 22933) {
            setReferralLink(path+'GOELECTRO');
            setReferralCode('GOELECTRO');
        }
        else if(loginData && loginData.seller_id === 6032) {
            setReferralLink(path+'GOELECTRO');
            setReferralCode('GOELECTRO');
        }
        else if(loginData && loginData.seller_id === 199) {
            setReferralLink(path+'GORAJELEC');
            setReferralCode('GORAJELEC');
        }
        else if(loginData && loginData.seller_id === 1599) {
            setReferralLink(path+'GORAMESH');
            setReferralCode('GORAMESH');
        }
        else if(loginData && loginData.seller_id === 15544) {
            setReferralLink(path+'GOSAIENT');
            setReferralCode('GOSAIENT');
        }
        else if(loginData && loginData.seller_id === 24329) {
            setReferralLink(path+'GOJAINELEC');
            setReferralCode('GOJAINELEC');
        }
        else if(loginData && loginData.seller_id === 1973) {
            setReferralLink(path+'GOSHREEGT');
            setReferralCode('GOSHREEGT');
        }
        else if(loginData && loginData.seller_id === 11063) {
            setReferralLink(path+'GOTHINKINF');
            setReferralCode('GOTHINKINF');
        }

    }

    const decode = (link) => {
      return  link.replace(/\s/g , "-")
    }

    const fetchStoreLink = () => {
        if (
            window.location.href.indexOf("test") > -1 ||
            window.location.href.indexOf("localhost") > -1
        ) {
            return (`https://gostor.vercel.app/store/${loginData.name}?storeId=${loginData.seller_id}`);
        }
        return (`https://gostor.com/store/${loginData.name}?storeId=${loginData.seller_id}`);
    }

    const broadcast = async () => {
        setBtnLoader(true);
        let reqObj = {
            type: 'STORE'
        }
        await sendBroadcast(reqObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `SMS is broadcasted to all your customers!!`
                setAlertFnc(msg, successColor, true);
            }
            else {
                setAlertFnc(res.data.msg, errorColor, true);
            }
        })
        setBtnLoader(false);
    }

    const referralBroadcast = async () => {
        setReferralBtnLoader(true);
        let reqObj = {
            type: 'REFERRAL',
            referralCode:referralCode

        }
        await sendBroadcast(reqObj).then((res) => {
            if (res && res.data && res.data.status === 'success') {
                let msg = `SMS is broadcasted to all your customers!!`
                setAlertFnc(msg, successColor, true);
            }
            else {
                setAlertFnc(res.data.msg, errorColor, true);
            }
        })
        setReferralBtnLoader(false);
    }

    //function to show alerts
    const setAlertFnc = (msg, type, show) => {
        setShowAlert(show);
        setAlertObj({ msg: msg, color: type })
    }

    return <div className={styles.mainContainer}>
        <div>
            <h5>SMS Broadcast</h5>
            < AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
            <Button variant="contained" color="primary" className="mt-2 mb-2" onClick={() => history.push({ pathname: "/customer-details" })}>Add/View customer details</Button>
        </div>
        <Grid container spacing={3} >
            <Grid item md={6}>
                <Paper className={styles.wrapper} elevation={2}>
                    <h6 className="text-left mb-0">SMS Template 1</h6>
                    <div className="d-flex justify-content-end mt-3 mb-3">
                        <p className="mb-0" style={{ lineHeight: '1.8', fontWeight: '400' }}>
                            Dear Customer,
                            <br />
                            <span >{loginData.name}</span>  is online now with Gostor.
                            Click on this link  <a className="text-dark" href={fetchStoreLink()} target="_blank"> {decode(fetchStoreLink())} </a>  to check our catalogue and place orders. Call us on <span>{loginData.username}</span> if you have any queries.
                            Thank you.
                        </p>
                    </div>
                    <div className="d-flex justify-content-end">
                        <Button variant="contained" color="primary" onClick={() => !btnLoader ? broadcast() : null}>
                            Broadcast SMS
                            {btnLoader ? <CircularProgress className="ml-2" style={{ color: 'white' }} size={15} /> : null}
                        </Button>
                    </div>
                    <div className="d-flex justify-content-end">
                        <small className="text-muted p-1">*SMS will be broadcasted to all your customers</small>
                    </div>
                </Paper>
            </Grid>
            </Grid>
            {
                referralCode?
            <Grid container spacing={3} >
            <Grid item md={6}>
                <Paper className={styles.wrapper} elevation={2}>
                    <h6 className="text-left mb-0">SMS Template 2</h6>
                    <div className="d-flex justify-content-end mt-3 mb-3">
                        <p className="mb-0" style={{ lineHeight: '1.8', fontWeight: '400' }}>
                            Dear Customer,
                            <br />
                            <span >{loginData.name}</span>  is online now with Gostor. Sign-up and get upto Rs.10,000 instant discount on all the products.
                            Visit <a className="text-dark" href={referralLink} target="_blank"> {referralLink} </a> or use our referral code to check the catalog and place orders.
                            <br/>
                            Referral Code: <strong>{referralCode}</strong> 
                        </p>
                    </div>
                    <div className="d-flex justify-content-end">
                        <Button variant="contained" color="primary" onClick={() => !referralBtnLoader ? referralBroadcast() : null}>
                            Broadcast SMS
                            {referralBtnLoader ? <CircularProgress className="ml-2" style={{ color: 'white' }} size={15} /> : null}
                        </Button>
                    </div>
                    <div className="d-flex justify-content-end">
                        <small className="text-muted p-1">*SMS will be broadcasted to all your customers</small>
                    </div>
                </Paper>
            </Grid>
        </Grid>
        :null}
    </div>
}

export default SMSBroadcast;